import { Component } from 'react';
import './App.scss';
import {
  BrowserRouter, Switch,
  Redirect, Route,
} from "react-router-dom";
import PrivateRoute from './Routes/PrivateRoute';
import Login from './Components/Login/login';
import ExternalLogin from './Components/Login/externalLogin';
import AdminSignup from './Components/Admin/Admin-Signup/signup';
import Adminaccount from './Components/Admin/Admin-Signup/admin-account';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import $ from 'jquery';
import { Helmet } from "react-helmet";
import axios from 'axios';
import Signup from './Components/Signup/signup';


class App extends Component {

  state = {
    company: '',
    banner: ''
  }

  componentDidMount = async () => {
    axios.get(process.env.REACT_APP_API_KEY + "company/logo")
      .then((response) => {
        if (response.data.success) {
          this.setState({
            logo: response.data.logo,
            company: response.data.company_name,
            whitelabled: response.data.whitelabled
          }, () => {
            localStorage.setItem("logo", response.data.logo);
            localStorage.setItem("company", response.data.company_name);
            localStorage.setItem('whitelabelled', JSON.stringify(response.data.whitelabled));
            localStorage.setItem('theme', JSON.stringify(response.data.colors));
          }
          );
        } else {
          this.setState({
            nofound: true,
          });
        }
      }).catch((error) => {
        if (error.response === undefined) {
          this.setState({
            successEnable: true,
            successMessageText: "Something went wrong",
          });
        } else if (error.response.status === 404) {
          this.setState({
            nofound: true,
          });
        } else if (error.response.status === 400) {
          this.setState({
            successEnable: true,
            successMessageText: error.response.data.message || "Something went wrong",
          });
        } else if (error.response.status === 500) {
          this.setState({
            successEnable: true,
            successMessageText: error.response.data.message || "Something went wrong",
          });
        } else {
          this.setState({
            successEnable: true,
            successMessageText: "Something went wrong",
          });
        }
      });
    this.detectBrowser();
    if (!localStorage.getItem('banner')) {
      localStorage.setItem('banner', false);
      this.setState({
        banner: false
      })
    }
    else if (localStorage.getItem('banner') === 'true') {
      this.setState({
        banner: true
      })
    }
    $(".layout").hide();
  }
  detectBrowser = () => {
    var browser = (function (agent) {
      switch (true) {
        case agent.indexOf("edge") > -1: return "Edge";
        case agent.indexOf("edg/") > -1: return "Chromium based Edge (dev or canary)"; // Match also / to avoid matching for the older Edge
        case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
        case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
        case agent.indexOf("trident") > -1: return "IE";
        case agent.indexOf("firefox") > -1: return "Mozila Firefox";
        case agent.indexOf("safari") > -1: return "Safari";
        default: return "other";
      }
    })(window.navigator.userAgent.toLowerCase());
    localStorage.setItem('browser', browser)
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
      localStorage.setItem('device', 'Mobile')
    }
    else {
      localStorage.setItem('device', 'desktop')
    }
  }

  closeBanner = () => {
    localStorage.setItem('banner', true);
    this.setState({
      banner: true
    })
  }

  render() {
    if (process.env.NODE_ENV === 'production') {
      console.log = function no_console() { };
    }

    const { theme } = this.props

    // const date = 'Wed Jun 22 2022 13:25:38 GMT+0530 (India Standard Time)';
    // var now = moment(date)
    // var end = moment(new Date())
    // var hours = end.diff(now, 'hours');

    return (
      <BrowserRouter >
        <ThemeProvider theme={theme} >
          <Helmet>
            <title>{`${this.state.company} - Elite Learning`}</title>
            <meta name="description" content={`Elite Learning - leading upskilling platform helps ${localStorage.getItem('company')} to upskill, and drive growth among employees.`} />
          </Helmet>
          <div className="layout" id="layout"></div>
          <div style={{ overflowX: window.innerWidth > 767 ? '' : 'hidden' }}>
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/signup" component={Signup} />
              <Route exact path="/external-login" component={ExternalLogin} />
              <Route exact path="/admin-signup" component={AdminSignup} />
              <Route exact path="/verify" component={Adminaccount} />
              {/* <Route component={window.location.pathname === '/login' || window.location.pathname === '/admin-signup' || window.location.pathname === '/verify' ? '' : Sidebar} /> */}
              {window.location.search.includes('skill_id') ?
                <PrivateRoute /> :
                localStorage.getItem('loginToken') === null ?
                  <Redirect from="/" to="/login" /> :
                  <PrivateRoute />
              }
            </Switch>
          </div>
          {/* {
            this.state.banner ?
              null :
              <div className="smart-banner">
                <div className="text-center position-relative" style={{ color: '#fff', width: window.innerWidth > 767 ? '100%' : '75%' }}>
                  Important message: Due to scheduled maintenance on Sunday 27th August, 12 AM to 6 AM (IST), this platform will be inaccessible during the maintenance window.
                </div>
                <div className='close-icon' onClick={() => this.closeBanner()}>
                  <img src='/images/close-white.svg' alt='' />
                </div>
              </div>
          } */}
        </ThemeProvider>
      </BrowserRouter >

    );
  }

}

const mapStateToProps = (state) => {
  const { user } = state.login
  const { theme, companyDetails } = state.account
  return {
    user, theme, companyDetails
  }
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(App)
